import styled from 'styled-components';
type OptionItemLabelProps = {
  cursor?: string;
  strikethrough?: boolean;
};

export const OptionItemLabel = styled.span.attrs({
  className: 'form-check-label',
})<OptionItemLabelProps>`
  margin-top: 2px;
  cursor: ${(props) => props.cursor || 'default'};
  ${(props) =>
    props.strikethrough
      ? `
    text-decoration: line-through;
    `
      : ``};
`;

export const HeaderOptionItemLabel = styled(OptionItemLabel)`
  text-align: left;
`;

export const PortfolioDropdownItemLabel = styled(OptionItemLabel)`
  margin-top: 5px;
`;
